import { View, Text, Image } from "@react-pdf/renderer";
import { styles } from "./PdfStyles";
import reelLogoBw from "../images/reel-logo-bw.png";

/**
 * PdfPageFooter — fixed footer that repeats on every PDF page.
 * Left: REEL OUTLINE™ logo image
 * Right: Page X of Y
 */
export const PdfPageFooter = () => (
  <View style={styles.pageFooter} fixed>
    {/* Left spacer — mirrors the page number width so logo stays centered */}
    <View style={{ flex: 1 }} />

    {/* Centered REEL logo */}
    <Image
      src={reelLogoBw}
      style={{ height: 45, objectFit: "contain" }}
    />

    {/* Right: Page X of Y */}
    <View style={{ flex: 1, alignItems: "flex-end" }}>
      <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} of ${totalPages}`
        }
      />
    </View>
  </View>
);
